import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { getParticipantFullName } from "../../../../../utils/participantDisplayName.js";
import API_BASE_URL from "../../../../../config/config.js";
import ModalEditInstitution from "../../../../Modals/ModalEditInstitution/ModalEditInstitution";
import { useSisdeuImportStatus } from "../../../../../hooks/useSisdeuImportStatus.js";

// toast
import { toast } from "react-hot-toast";

const Regionales2 = () => {
  const regions = [
    "REGIÓN LIMA",
    "REGIÓN NORTE",
    "REGIÓN CENTRO",
    "REGIÓN SUR",
  ];
  const { idevent, idsport } = useParams();
  // FTR-0048: con la importación SISDEU nueva activa para el evento (company 1) se oculta el sync legacy.
  const { status: sisdeuImportStatus } = useSisdeuImportStatus({ idevent, idsport });
  const [participantsByRegion, setParticipantsByRegion] = useState({
    LIMA: [],
    NORTE: [],
    CENTRO: [],
    SUR: [],
  });
  const [selectedParticipant, setSelectedParticipant] = useState(null);
  const [posicion, setPosicion] = useState("");
  const [tag, setTag] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const getParticipantes = async () => {
      try {
        const response = await axios.post(
          `${API_BASE_URL}/getparticipantsregion`,
          {
            idevent: Number(idevent),
            idsport: Number(idsport),
            idtypephase: 1,
          }
        );

        const organizedParticipants = {
          LIMA: [],
          NORTE: [],
          CENTRO: [],
          SUR: [],
        };

        response.data.forEach((participant) => {
          console.log("a ver es", participant)
          const regionName =
            participant.Institution.departamento.region.name.toUpperCase();
          if (organizedParticipants[regionName]) {
            organizedParticipants[regionName].push(participant);
          }
        });

        // Ordenar los participantes por posición dentro de cada región
        Object.keys(organizedParticipants).forEach((region) => {
          organizedParticipants[region].sort((a, b) => {
            if (a.posicion === null || a.posicion === undefined) return 1;
            if (b.posicion === null || b.posicion === undefined) return -1;
            return a.posicion - b.posicion;
          });
        });

        setParticipantsByRegion(organizedParticipants);
      } catch (error) {
        console.error("Error fetching participants:", error);
      }
    };

    if (idevent && idsport) {
      getParticipantes();
    }
  }, [idevent, idsport]);

  const handleRowClick = (participant) => {
    setSelectedParticipant(participant);
    setPosicion(participant.posicion || "");
    setTag(participant.tag || "");
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleUpdateAcreditados = async () => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/actualizaracreditados`,
        {
          idevent: selectedParticipant.idevent,
          idsport: selectedParticipant.idsport,
          idinstitution: selectedParticipant.idinstitution,
        }
      );
      toast.success("¡Acreditados Actualizados!");
    } catch (error) {
      toast.error("¡Error al actualizar los Acreditados!");
      console.error("Error updating acreditados:", error);
    }
  };

  const handleUpdate = async () => {
    try {
      await axios.patch(`${API_BASE_URL}/updateposiciontag`, {
        idevent: selectedParticipant.idevent,
        idsport: selectedParticipant.idsport,
        idtypephase: selectedParticipant.idtypephase,
        idinstitution: selectedParticipant.idinstitution,
        posicion: posicion,
        tag: tag,
      });

      const response = await axios.post(
        `${API_BASE_URL}/getparticipantsregion`,
        {
          idevent: Number(idevent),
          idsport: Number(idsport),
          idtypephase: 1,
        }
      );

      setParticipantsByRegion((prevState) => {
        const updatedParticipants = { ...prevState };
        const regionName =
          selectedParticipant.Institution.departamento.region.name.toUpperCase();

        updatedParticipants[regionName] = response.data
          .filter(
            (p) =>
              p.Institution.departamento.region.name.toUpperCase() ===
              regionName
          )
          .sort((a, b) => {
            if (a.posicion === null || a.posicion === undefined) return 1;
            if (b.posicion === null || b.posicion === undefined) return -1;
            return a.posicion - b.posicion;
          });

        return updatedParticipants;
      });

      setIsModalOpen(false);
      toast.success("¡Posición o Tag Actualizado!");
    } catch (error) {
      toast.error("¡Error al Actualizar Posición o Tag!");
      console.error("Error updating participant:", error);
    }
  };

  return (
    <div className="p-6 grid gap-6 grid-cols-1 md:grid-cols-2">
      {regions.map((region, index) => (
        <div
          key={index}
          className="bg-white rounded-lg shadow-md p-4 overflow-x-auto"
        >
          <h2 className="text-center text-xl font-bold mb-4">{region}</h2>
          <table className="min-w-full divide-y divide-gray-200">
            <thead>
              <tr>
                <th className="px-4 py-2 text-left text-sm font-medium text-gray-500 uppercase tracking-wider">
                  Participante
                </th>
                <th className="px-4 py-2 text-left text-sm font-medium text-gray-500 uppercase tracking-wider">
                  Condición
                </th>
                <th className="px-4 py-2 text-left text-sm font-medium text-gray-500 uppercase tracking-wider">
                  Sigla
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {participantsByRegion[region.split(" ")[1]].map(
                (participant, idx) => (
                  <tr
                    key={idx}
                    onClick={() => handleRowClick(participant)}
                    className="cursor-pointer"
                  >
                    <td className="px-4 py-2 whitespace-nowrap flex items-center">
                      <img
                        src={`${participant.Institution.path_base}${participant.Institution.image_path}`}
                        alt="Logo"
                        className="w-8 h-8 rounded-full object-cover mr-2"
                      />
                      {getParticipantFullName(participant)}
                    </td>
                    <td className="px-4 py-2 whitespace-nowrap">
                      {participant.tag || "N/A"}
                    </td>
                    <td className="px-4 py-2 whitespace-nowrap">
                      {participant.Institution.abrev}
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>
      ))}

      <ModalEditInstitution
        isModalOpen={isModalOpen}
        handleModalClose={handleModalClose}
        posicion={posicion}
        setPosicion={setPosicion}
        tag={tag}
        setTag={setTag}
        handleUpdate={handleUpdate}
        handleUpdateAcreditados={handleUpdateAcreditados}
        showUpdateAcreditados={!sisdeuImportStatus.integrationActive}
      />
    </div>
  );
};

export default Regionales2;
